import useGetUserSettingWithPreference from '../../common/category/useGetUserSettingWithPreference'
import { PanelContainer } from '../../common/panel/PanelContainer'
import SideBarUserManagement from '../SideBarUserManagement'
import { Title } from '../Title'
import '../lang/i18n'
import { Preferences } from './preferences'
import { Settings } from './settings'

export const SettingPreferences = () => {
  const { loading, userSettings } = useGetUserSettingWithPreference()

  const renderBottomComponent = () => {
    return (
      <>
        <PanelContainer>
          <Settings />
          <Preferences userSettings={userSettings} />
        </PanelContainer>
      </>
    )
  }

  return (
    <SideBarUserManagement
      renderTopComponent={() => <Title text="settingPreferences.TITLE" />}
      renderBottomComponent={renderBottomComponent}
      isLoadingContent={loading}
    />
  )
}
